import React, { useState, useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'
import Cropper from 'react-easy-crop'
import UploadCropImagePopup from '../UploadCropImagePopup'

const ThumbnailsUpload = (props) => {
  return (
    <Fragment>
      <div>
        <div className='upload-image' onClick={() => props.setModalOpen(true)}>
          {window.I18n.t('views.golfhub.thumbnails_upload.upload_image')}
        </div>
      </div>
    </Fragment>
  )
}

export const ThumbnailsUploadPopup = (props) => {
  const [ imagePreview, setImagePreview ] = useState({ image: '', crop: ''})
  const [ disableImageSave, sedDisableImageSave ] = useState(true)
  const [ crop, setCrop ] = useState({ x: 0, y: 0 })
  const [ zoom, setZoom ] = useState(1)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (imagePreview.image) {
      setImagePreview({image: imagePreview.image, imageFile: imagePreview.imageFile, crop: croppedAreaPixels})
    }
  }, [ imagePreview.image ])

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    setImagePreview({image: URL.createObjectURL(file), imageFile: file, crop: ''})

    let message = ''
    if (file.size > 6000000) { // bytes
      message = 'File exceeds maximum size.'
    }
    
    if ([ 'image/jpeg', 'image/png', 'image/gif', 'image/bmp' ].indexOf(file.type) < 0) {
      message += ' File format should be jpg, jpeg, gif, png, bmp.'
    }

    if (message !== '') {
      $('.error-message').removeClass('hidden')
      $('.error-message').html(message)
      sedDisableImageSave(true)

    } else {
      $('.error-message').addClass('hidden').disabled = false
      sedDisableImageSave(false)
    }
  }

  const handleModalClose = () => {
    props.setModalOpen(false)
    setImagePreview({ image: '', crop: ''})
  }

  const saveImage = () => {
    props.setNewThumbnail(imagePreview)
    handleModalClose()
  }

  return (
    <UploadCropImagePopup
      isOpen={props.modalOpen}
      onClose={() => handleModalClose()}
      onConfirm={() => saveImage()}
      isConfirmDisabled={!imagePreview.image || disableImageSave}
      confirmText={window.I18n.t('views.golfhub.thumbnails_upload.done')}
      title={window.I18n.t('views.golfhub.thumbnails_upload.upload_thumbnail_title')}
      imagePreviewSrc={imagePreview.image}
      imagePreviewComponent={
        <div className='crop-container'>
          <Cropper
            image={imagePreview.image}
            crop={crop}
            zoom={zoom}
            aspect={16 / 9}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom} />
        </div>}
      imagePreviewHeader={window.I18n.t('views.golfhub.thumbnails_upload.thumbnail_preview')}
      imagePreviewDetails={window.I18n.t('views.golfhub.image_preview_details')}
      handleImageUpload={handleImageUpload}
      photoFormats={window.I18n.t('views.golfhub.accepted_formats')}
      photoRequirements={window.I18n.t('views.golfhub.thumbnail_acceptable_format')}
      uploadLabel={window.I18n.t('views.golfhub.upload_crop_image.upload_thumbnail')}
    />
  )
}

ThumbnailsUpload.propTypes = {
  setModalOpen: PropTypes.func,
}

ThumbnailsUploadPopup.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  setNewThumbnail: PropTypes.func,
}

export default ThumbnailsUpload
